import TabsGroup from './components/TabsGroup';
export {default as IconStatsTabTitle} from './components/IconStatsTabTitle';

export default TabsGroup;
